import Providers from './providers';
import Routes from './routes';

function App() {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}

export default App;
